import { FlexBox, Typography } from '@vp/swan';
import { DateFormatter, DateFormatTypes } from '@vp/om-date-formatter';
import { useTranslations } from '@vp/om-translations';
import { Currency } from '@vp/om-currency';
import { useSiteData } from '../../hooks/useSiteData';
import { useOrderSummary } from '../contexts/OrderSummaryContext';

export const OrderInfoDisplay = () => {
  const [orderHistoryMessages = {}, orderSummaryMessages = {}] =
    useTranslations(['orderHistoryMessages', 'orderSummaryMessages']);

  const { locale } = useSiteData();

  const {
    order: {
      orderNumber,
      orderCreationDate,
      orderPriceSummary: {
        currency,
        fractionDigits,
        orderTotalDiscountedPrice,
      },
    },
  } = useOrderSummary();

  const showOrderTotal = currency !== '';

  return (
    <FlexBox flexDirection="column" mb={{ xs: 5, sm: 6 }}>
      <div>
        <FlexBox
          flexDirection={{ sm: 'column', md: 'row' }}
          flexWrap="wrap"
          py={3}
        >
          <Typography fontWeight="bold" mr={2}>
            {orderHistoryMessages.orderNumberField}:
          </Typography>
          <Typography>{orderNumber}</Typography>
        </FlexBox>
        <FlexBox
          flexDirection={{ sm: 'column', md: 'row' }}
          flexWrap="wrap"
          py={3}
        >
          <Typography fontWeight="bold" mr={2}>
            {orderHistoryMessages.orderDateField}:
          </Typography>

          <DateFormatter
            date={orderCreationDate}
            locale={locale}
            formatType={DateFormatTypes.MEDIUM_FMT}
          />
        </FlexBox>
        {showOrderTotal ? (
          <FlexBox
            flexDirection={{ sm: 'column', md: 'row' }}
            flexWrap="wrap"
            py={3}
          >
            <Typography fontWeight="bold" mr={2}>
              {orderSummaryMessages.totalPaidField}:
            </Typography>
            <Currency
              locale={locale}
              currency={currency}
              cents={orderTotalDiscountedPrice?.taxed || 0}
              fractionDigits={fractionDigits}
            />
          </FlexBox>
        ) : null}
      </div>
    </FlexBox>
  );
};
